// extracted by mini-css-extract-plugin
export default {"container":"NotFound_page_container__XAvPu"};